import React from 'react';
import { Link } from 'gatsby';

export default function LinkWithQuery({ children, to, fragmentIdentifier, ...props }) {
	const search = typeof window !== 'undefined' ? window.location.search : '';

	// check if to prop has a ending slash, and if it doesn't add it
	if (to && to[to.length - 1] !== '/') to = to + '/';

	if (search) to = to + search;

	if (fragmentIdentifier) to = to + '#' + fragmentIdentifier;

	return (
		<Link to={to} {...props}>
			{children}
		</Link>
	);
}
